import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl } from '../../http/urls';
import { FimboForSelection, LessonGeneratorRequest, LessonGeneratorResponse } from '../../models/Models';
import { getCookie } from '../../http/cookies';

export const lessonGeneratorAPI = createApi({
  reducerPath: 'lessonGeneratorAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl + '/api/lesson-generator/',
  }),
  tagTypes: ['LessonGenerator'],
  endpoints: (build) => ({
    generateLessons: build.mutation<LessonGeneratorResponse, LessonGeneratorRequest>({
      query: (body) => ({
        url: 'generate',
        method: 'POST',
        body,
        headers: {
          Authorization: `Bearer ${getCookie('token')}`,
        },
      }),
      invalidatesTags: ['LessonGenerator'],
    }),
    getFimbosForSelection: build.query<FimboForSelection[], void>({
      query: () => ({
        url: 'fimbos',
        headers: {
          Authorization: `Bearer ${getCookie('token')}`,
        },
      }),
      providesTags: ['LessonGenerator'],
    }),
  }),
});

export const { useGenerateLessonsMutation, useGetFimbosForSelectionQuery } = lessonGeneratorAPI;
